import React from 'react';
import {getMarket} from '../utils/market';
export default function RegionalServiceAreasPicker({value=[],onChange,countryCode='PA'}) {
 const market=getMarket(countryCode);
 const patch=(index,change)=>onChange(value.map((area,i)=>i===index?{...area,...change,country:countryCode}:area));
 return <section><h4>Zonas donde atiendes</h4><p>Agrega las ciudades o barrios disponibles para tus clientes. Los recargos se expresan en {market.currency}.</p>
 {value.map((area,i)=><div key={area.id || i} style={{display:'flex',gap:8,flexWrap:'wrap',marginBottom:10}}>
 <label>Ciudad o zona<input aria-label={`Zona de cobertura ${i+1}`} value={area.label || ''} onChange={e=>patch(i,{label:e.target.value})}/></label>
 <label>Recargo ({market.currency})<input aria-label={`Recargo de zona ${i+1}`} type="number" min="0" step="0.01" value={area.extraFee || 0} onChange={e=>patch(i,{extraFee:Math.max(0,Number(e.target.value)||0)})}/></label>
 <button type="button" onClick={()=>onChange(value.filter((_,index)=>index!==i))}>Quitar zona</button>
 </div>)}
 <button type="button" onClick={()=>onChange([...value,{id:`area-${Date.now()}`,country:countryCode,level:'zone',label:'Nueva zona',extraFee:0}])}>Agregar zona</button>
 </section>;
}
